import React from "react";
import { $t } from './i18n';
import { transformArray } from '@/utils/helper';

const Description = ({message = {}, children, id}) => {
  const desc = transformArray(message.desc)
  return (
    <section id={id}>
      <div className="content">
        <h2 className="section-title">{$t(message.title)}</h2>
        { children }
        {
          desc.map(item => <p key={item} className="desc">{item}</p>)
        }
      </div>
    </section>
  )
}

export default Description;
